<template>
  <section
    v-if="campaign.companies.length > 0"
    class="campaigns-companies"
  >
    <figure
      v-for="(company, index) in campaign.companies"
      :key="index"
      class="campaigns-companies__logo"
    >
      <picture>
        <source :data-srcset="getImageSrcset(company)">

        <img
          class="lazyload"
          data-sizes="auto"
          :data-src="getImageSrc(company)"
        >
      </picture>
    </figure>
  </section>
</template>

<script>
import campaigns from '@/mixins/campaigns';

export default {
  name: 'CampaignsCompanies',

  mixins: [campaigns]
};
</script>

<style lang="scss" src="@/assets/components/campaigns/campaigns-companies-view.scss"></style>



// WEBPACK FOOTER //
// campaigns-companies-view.vue